const Footer = ({ social, firstName }) => {
  const { facebook, twitter, github, linkedin, instagram } = social;
  return (
    <footer className="footer text-center">
      <div className="container">
        <div className="row">
          <div className="logo">
            <img src="img/logo-2.png" alt="logo" className="logo-1" />
          </div>

          <div className="scoial-icon text-center">
            {facebook && (
              <a href={facebook} target="_blank">
                <span>
                  <i className="fab fa-facebook-f"></i>
                </span>
              </a>
            )}
            {twitter && (
              <a href={twitter} target="_blank">
                <span>
                  <i className="fab fa-twitter"></i>
                </span>
              </a>
            )}
            {github && (
              <a href={github} target="_blank">
                <span>
                  <i className="fab fa-github"></i>
                </span>
              </a>
            )}
            {linkedin && (
              <a href={linkedin} target="_blank">
                <span>
                  <i className="fab fa-linkedin-in"></i>
                </span>
              </a>
            )}

            {instagram && (
              <a href={instagram} target="_blank">
                <span>
                  <i className="fab fa-instagram"></i>
                </span>
              </a>
            )}
          </div>

          <div className="cop">
            <h6>© 2018 Powered By Design {firstName}</h6>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
